export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14759.8b847ae7.jpg";